module.exports = __webpack_public_path__ + "static/media/Lecture1.39fee6ae.jpeg";